export const FEATURE_NAME = '@zerops/zerops/feature/client-user-role-dialog';
